import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { DatasetModel } from './types/dataset-model.interface';
import { DatasetModelImpl } from './models/dataset-model';
import { DatasetApi } from './types/dataset-api.interface';
import { DatasetPatentApiImpl } from './repository/dataset-patent-api';
import { DatasetService } from './types/dataset-service.interface';
import { DatasetServiceImpl } from './dataset-service';
import { DatasetPatentApiDto } from './types/dataset-patent-api-dto.interface';
import { DatasetPatentApiDtoImpl } from './repository/dataset-patent-api-dto';
export const dataset = new ContainerModule(bind => {
    bind(DatasetModel).to(DatasetModelImpl);
    bind(DatasetApi).to(DatasetPatentApiImpl);
    bind(DatasetService).to(DatasetServiceImpl);
    bind(DatasetPatentApiDto).to(DatasetPatentApiDtoImpl);
});
